import { Button } from "@maker/design-system/ui/button";
import * as docx from "docx";
import { DownloadIcon } from "lucide-react";
import { useParamsOrThrow } from "../../../../../hooks/use-params-or-throw";
import { useTranscriptionData } from "../../../../../hooks/use-transcriptions";
import { downloadBlob } from "../../../../../utils/download";
import { formatTimecode } from "../../../../../utils/time";

const TranscriptionsTranscriptionExportPage = () => {
	const { id } = useParamsOrThrow<"id">();
	const data = useTranscriptionData(id);

	const handleExport = () => {
		const doc = new docx.Document({
			sections: [
				{
					children: [
						new docx.Paragraph({
							heading: docx.HeadingLevel.HEADING_1,
							alignment: "center",
							children: [
								new docx.TextRun({
									text: data.title,
									color: "#000000",
								}),
								new docx.TextRun({
									break: 2,
								}),
							],
						}),
						...data.transcription.segments.map((segment) => {
							return new docx.Paragraph({
								alignment: "left",
								children: [
									new docx.TextRun({
										text: data.transcription.speakers.find(
											(speaker) => speaker.id === segment.words[0]?.speaker_id,
										)?.name,
										bold: true,
										font: "Arial",
										size: 14,
										break: 2,
									}),
									new docx.TextRun({
										text: " • ",
										size: 14,
									}),
									new docx.TextRun({
										text: segment.words[0]?.start
											? formatTimecode(segment.words[0].start)
											: "",
										bold: true,
										font: "Arial",
										size: 14,
										color: "#666666",
									}),
									new docx.TextRun({
										break: 1,
									}),
									...segment.words.map(
										(word) =>
											new docx.TextRun({
												text: word.text,
												font: "Arial",
												size: 18,
											}),
									),
								],
							});
						}),
					],
				},
			],
		});

		docx.Packer.toBlob(doc).then((blob) => {
			downloadBlob(blob, `${data.title}.docx`);
		});
	};

	return (
		<section className="p-6">
			<div className="grid grid-cols-4 gap-4">
				<div className="col-span-1">
					<div className="rounded-lg bg-neutral-50 p-4">
						<h3 className="mb-1 font-semibold text-neutral-800">docx</h3>

						<p className="mb-4 text-neutral-500 text-xs">
							Exporte a transcrição em formato docx, compatível com
							Office, Google Docs e LibreOffice.
						</p>

						<div>
							<Button variant="black" size="xs" onClick={() => handleExport()}>
								<DownloadIcon /> Exportar
							</Button>
						</div>
					</div>
				</div>

				<div className="col-span-1">
					<div className="rounded-lg bg-neutral-50 p-4">
						<h3 className="mb-1 font-semibold text-neutral-800">txt</h3>

						<p className="mb-4 text-neutral-500 text-xs">
							Exporte a transcrição em formato txt, compatível com
							Windows, macOS e Linux.
						</p>

						<div>
							<Button variant="black" size="xs" disabled>
								<DownloadIcon /> Exportar
							</Button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TranscriptionsTranscriptionExportPage;
